function legacyCopy(text) {
  const field = document.createElement('textarea');
  const previousFocus = document.activeElement;
  field.value = text;
  field.style.position = 'fixed'; field.style.opacity = '0';
  document.body.appendChild(field);
  try {
    field.select();
    return document.execCommand('copy');
  } catch {
    // No exception details are logged: callers can display a selectable share link.
    console.warn('[clipboard] Automatic copying unavailable; showing a manual copy link.');
    return false;
  } finally {
    field.remove();
    previousFocus?.focus();
  }
}

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // Denied Clipboard API permissions are expected in some embedded browsers.
    return legacyCopy(text);
  }
}